import React from 'react';
import DragDropFileOpener from '@components/DragAndDropFile/DragAndDropFile';
import { CSVModalButton, CSVModalButtonRow } from '../../Buttons';
import { CSV_UPLOAD_TEMPLATE_URL } from '../../vars';
import styles from './Upload.module.scss';
import { LoaderIcon } from '@repo/icons';
import { AlertBox } from '../Review';

export default function UploadView({
  selectFile,
  closeModal,
  upload,
  uploadDisabled,
  forceDarkMode,
  isParsing,
  parsingError,
}: {
  selectFile: (file: File) => void;
  closeModal: () => void;
  upload: () => void;
  uploadDisabled: boolean;
  forceDarkMode: boolean;
  isParsing: boolean;
  parsingError: boolean;
}) {
  return (
    <>
      <div className={styles.copy}>
        Import a list of people using a CSV file. Please make sure to follow our{' '}
        <a href={CSV_UPLOAD_TEMPLATE_URL} target="_blank">
          formatting guidelines
        </a>
        .
      </div>
      <DragDropFileOpener onFile={selectFile} />

      {parsingError && (
        <AlertBox title="Error parsing CSV file" status="error" className={styles.errorBox}>
          There was an error parsing the uploaded CSV file. Please make sure the file is formatted
          correctly.
        </AlertBox>
      )}

      <CSVModalButtonRow>
        <CSVModalButton onClick={closeModal} secondary forceDarkMode={forceDarkMode}>
          Cancel
        </CSVModalButton>
        <CSVModalButton disabled={uploadDisabled} onClick={upload} forceDarkMode={forceDarkMode}>
          {isParsing ? (
            <>
              Parsing <LoaderIcon width="12" />
            </>
          ) : (
            'Upload'
          )}
        </CSVModalButton>
      </CSVModalButtonRow>
    </>
  );
}
